import React, { useState, useRef } from "react";
import { Marker } from "./Marker";
export const Board = ({ board, onCellSelect }) => {
    const size = board.length;
    const [focusedCellState, setFocusedCell] = useState({
        row: 0,
        col: 0,
    });
    const cellRefs = useRef(new Map());
    const focusedCell = isInBounds(focusedCellState, size)
        ? focusedCellState
        : { row: 0, col: 0 };
    const handleKeyDown = (e, currentCell) => {
        var _a;
        const newCell = calculateMovementOutcome(e, board, currentCell);
        // Only call preventDefault if we calculated movement.
        // This means the browser will still handle other keypresses as normal.
        if (newCell !== null) {
            e.preventDefault();
            setFocusedCell(newCell);
            (_a = cellRefs.current.get(keyForCell(newCell))) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    const setCellButtonRef = (cell) => (el) => {
        const key = keyForCell(cell);
        if (el) {
            cellRefs.current.set(key, el);
        }
        else {
            cellRefs.current.delete(key);
        }
    };
    return (React.createElement("div", { role: "grid", "aria-label": "Tic-tac-toe board", style: {
            gridTemplateColumns: `repeat(${size}, minmax(0, 1fr))`,
            gridTemplateRows: `repeat(${size}, minmax(0, 1fr))`,
        }, className: "grid gap-1 bg-gray-900 w-full max-w-md aspect-square" }, board
        .map((rowCells, row) => rowCells.map((value, col) => {
        const cell = { row, col };
        const isFocused = isCellEqual(cell, focusedCell);
        const key = keyForCell(cell);
        return (React.createElement("button", { key: key, "data-testid": key, ref: setCellButtonRef(cell), tabIndex: isFocused ? 0 : -1, "aria-label": `Row ${row + 1}, Column ${col + 1}, ${value !== null && value !== void 0 ? value : "empty"}`, className: "bg-white cursor-pointer flex items-center justify-center aspect-square\n                           outline-none\n                           focus-visible:shadow-[inset_0_0_0_4px_white,inset_0_0_0_8px_rgb(59,130,246)]", onClick: () => onCellSelect(cell), onKeyDown: (e) => handleKeyDown(e, { row, col }), onFocus: () => setFocusedCell({ row, col }) }, value && React.createElement(Marker, { value: value })));
    }))
        .flat()));
};
const isInBounds = (cell, size) => cell.row < size && cell.col < size;
const isCellEqual = (cell1, cell2) => cell1.row === cell2.row && cell1.col === cell2.col;
const keyForCell = ({ row, col }) => `cell-${row}-${col}`;
// Given a board, a cell and a keypress, return the new cell or null if the keypress
// did not cause movement
const calculateMovementOutcome = (e, board, { row, col }) => {
    const size = board.length;
    switch (e.key) {
        case "ArrowUp":
            return { row: (row - 1 + size) % size, col };
        case "ArrowDown":
            return { row: (row + 1) % size, col };
        case "ArrowLeft":
            return { row, col: (col - 1 + size) % size };
        case "ArrowRight":
            return { row, col: (col + 1) % size };
        default:
            return null;
    }
};
